// extracted by mini-css-extract-plugin
module.exports = {"body":"GenericUpsell_body__msqRV"};